<!--=================================
 preloader -->
<div id="pre-loader" *ngIf="commondata.loader.value">
    <img src="assets/images/pre-loader/loader-01.svg" alt="">
</div>
<div class="page-wrapper">
    <div class="authentication-box">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-5 p-0 card-left d-none d-md-block">
                    <div class="card bg-primary mb-0">
                        <div class="svg-icon1 d-flex justify-content-center">
                            <img alt="" class="my-2" src="assets/images/{{logo}}">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-7 p-0 card-right">
                    <div class="card tab2-card p-4">
                        <div class="card-body">
                            <h4 class="login-text">Set Password</h4>
                            <div class="tab-pane fade active show mt-4">
                                <form autocomplete="off" [formGroup]="setPassword"
                                      class="form-horizontal auth-form1" novalidate="">
                                    <div class="form-group">
                                        <input autocomplete="new-password" formControlName="userName" type="text"
                                               class="form-control" placeholder="Email"
                                               id="exampleInputEmail1">
                                        <em class="error" *ngIf="!setPassword.get('userName').valid && (setPassword.get('userName').dirty || setPassword.get('userName').touched)">Email is required</em>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input (input)="checkConfirmPassword()" autocomplete="new-password" required formControlName="password" type="password"
                                                   class="form-control" placeholder="Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps ? 'password' : 'text'">
                                            <div class="input-group-append cursor" (click)="conps = !conps">
                                                <span class="input-group-text" id="basic-addon3">
                                                    <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <em class="error" *ngIf="setPassword.get('password').hasError('required') && (setPassword.get('password').dirty || setPassword.get('password').touched)">Password is required</em>
                                        <em class="error help-block" *ngIf="setPassword.get('password').hasError('minlength')">Minimum 5 characters required</em>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input (input)="checkPasswords()" autocomplete="new-password" formControlName="confirmPassword" required type="password"
                                                   class="form-control" placeholder="Confirm Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps1 ? 'password' : 'text'">
                                            <div class="input-group-append cursor" (click)="conps1 = !conps1">
                                                <span class="input-group-text" id="basic-addon2">
                                                    <i [class]="conps1 ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div *ngIf="setPassword.controls['confirmPassword'].touched && !setPassword.controls['confirmPassword'].valid">
                                            <em class="error help-block" *ngIf="setPassword.controls['confirmPassword'].hasError('required') " >
                                                Enter Confirm Password
                                            </em>
                                        </div>
                                        <div *ngIf="passwordValid">
                                            <em class="error help-block">
                                                Enter same password as above
                                            </em>
                                        </div>
                                    </div>
                                    <div class="form-button">
                                        <button class="btn btn-primary w-100" (click)="update()">Submit<i class="ml-2 fa fa-long-arrow-right fa-1x" aria-hidden="true"></i></button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
